const dlPush = (args: object) => {
  window.dataLayer = window.dataLayer ? window.dataLayer : [];
  window.dataLayer.push(args);
};

export default dlPush;
